import {doc} from './docs.js';

doc(
    "envelope.attack",
    {
        number: "",
    },
    "Triggers envelope specified by nnumber",
    () => 0,
);
export const envelopeAttack = (object, number) => {
    return () => {
        let subSequence = object.subSequence;
        while (!subSequence.tracks && subSequence.subSequence) {
            subSequence = subSequence.subSequence;
        }
        let envelope = subSequence.envelopesTrack.envelopes[number() || 0].envelope;
        envelope.triggerAttack();
    };
};

doc(
    "envelope.release",
    {
        number: "",
    },
    "Triggers envelope specified by nnumber",
    () => 0,
);
export const envelopeRelease = (object, number) => {
    return () => {
        let subSequence = object.subSequence;
        while (!subSequence.tracks && subSequence.subSequence) {
            subSequence = subSequence.subSequence;
        }
        let envelope = subSequence.envelopesTrack.envelopes[number() || 0].envelope;
        envelope.triggerRelease();
    };
};

export const envelope = {
    "envelope.attack": envelopeAttack,
    "envelope.release": envelopeRelease
};
